// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__oGLmw","content":"style_content__KG4DT"};